import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard, NoAuthGuard } from './core/guards';
import { DocumentViewMode } from './core/models/document';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/auth/login',
  },
  {
    path: 'auth',
    canActivate: [NoAuthGuard],
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
  {
    path: 'document/:id/checkpoint/:checkpointId',
    data: {
      mode: DocumentViewMode.View,
    },
    canActivate: [AuthGuard],
    loadChildren: () => import('./document/document.module').then((m) => m.DocumentModule),
  },
  {
    path: 'document/:id',
    data: {
      mode: DocumentViewMode.Edit,
    },
    canActivate: [AuthGuard],
    loadChildren: () => import('./document/document.module').then((m) => m.DocumentModule),
  },
  {
    path: 'group/:id',
    canActivate: [AuthGuard],
    loadChildren: () => import('./group/group.module').then((m) => m.GroupModule),
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
